import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=0bdcfc64"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdcfc64')) {
      api.createRecord('0bdcfc64', component.options)
    } else {
      api.reload('0bdcfc64', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=0bdcfc64", function () {
      api.rerender('0bdcfc64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/Modal.vue"
export default component.exports